module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljirooraeorae-2@3x.ver2_0_2.jpg?72da091b";